.textContent p {
  margin-top: 15px;
}
